import v8n from 'v8n'

export const allowAddTransitStockArrival = (date, quantity, setErrorFields) => {
    const validDate = v8n().string().minLength(1).test(date)
    const validQuantity = quantity !== "" && quantity !== null && quantity !== undefined && !isNaN(parseFloat(quantity))

    if (validDate && validQuantity) {
        setErrorFields({ date: false, quantity: false })
        return true
    }

    setErrorFields({ date: !validDate, quantity: !validQuantity })
    return false
}
